(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpInputFile', cpInputFile);

    cpInputFile.$inject = [];

    function cpInputFile() {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/caffeprint/directives/input-file/input-file.html',
            scope: {
                title: '@',
                object: '=',
                prop: '@',
                isDisabled: '=?',
                onChange: '&?',
                previewName: '=?'
            },
            link: function(scope, element, attrs, controller) {
                scope.inputChange = inputChange;
                scope.preview = undefined;
                scope.isSelected = undefined;

                // Value loaded from the server, cleared below by the directive itself
                var loadedValue;

                scope.$watch('object[prop]', function(newValue, oldValue) {
                    // Clearing the loaded value is not a reset, keep the preview
                    if (loadedValue !== undefined && oldValue === loadedValue && newValue === undefined) {
                        loadedValue = undefined;
                        return;
                    }

                    if (oldValue && !newValue) {
                        element.find('input[type="file"]').val('');
                        element.find('.fileinput-filename').text('');
                        element.find('.fileinput').removeClass('fileinput-exists').addClass('fileinput-new');
                        scope.isSelected = false;
                        scope.preview = undefined;
                    }
                });

                scope.$watch('object', function(newValue, oldValue) {
                    if (scope.object && scope.object[scope.prop]) {
                        if (scope.previewName) {
                            scope.preview = scope.object[scope.prop].split('/').pop();
                        } else {
                            scope.preview = scope.object[scope.prop];
                        }

                        scope.isSelected = scope.object[scope.prop] ? true : false;
                        loadedValue = scope.object[scope.prop];
                        scope.object[scope.prop] = undefined;
                    }
                });

                function inputChange(elem) {
                    scope.$apply(function() {
                        if (elem.files.length) {
                            scope.object[scope.prop] = elem.files[0];
                            scope.isSelected = true;
                        } else {
                            scope.object[scope.prop] = '';
                            scope.isSelected = false;
                        }

                        if (scope.preview) {
                            scope.preview = undefined;
                        }
                    });

                    if (scope.onChange) {
                        scope.onChange();
                    }
                }
            }
        };
    }
})();
